// Performance appreciation tile data extracted from signed client certificates.
// Used by both Home and About pages via the <PerformanceCarousel/> component.
//
// Display order (set by client, Jan 2026):
//   Samsung → Nxtra → CtrlS → DaeMyoung → Bikaner → Mother Dairy → DS Group → MASU

export const PERFORMANCE_TILES = [
  // 1) Samsung Engineering India (Chennai)
  {
    id: 'samsung-chennai',
    badge: 'Samsung Standard · HV/LV',
    quoteHtml:
      '"Tricolite Energy Solutions possesses <b>proficient engineering skills and execution know-how</b> which they demonstrated throughout this project. The quality of work carried out is <em>up to our international Samsung standards</em>. A total of <b>14,600 accident-free safe manhours</b> were recorded between mobilization and completion. They have successfully commissioned our <em>main substation and compressor plant</em> electrical work at Samsung Engineering India, Chennai."',
    person: 'Mr. Doosin Jung',
    role: 'Project Director — Electrical',
    company: 'Samsung Engineering India',
    initials: 'DJ',
    initialsGradient: 'from-[#1428a0] to-[#0a1670]',
    logo: '/clients/logo-8.webp',
  },

  // 2) Nxtra by Airtel
  {
    id: 'nxtra',
    badge: 'Data Centre · 4 MW',
    quoteHtml:
      '"The EPC team of Tricolite Energy Solutions has <b>successfully commissioned our HT &amp; LT Panel works for 4 MW DC</b> at Nxtra Data Limited, Pune. A total of <em>12,181 accident-free safe man-hours</em> were recorded at site between mobilization and handing over. We do not shy to <b>recommend them to all who need affordable, clean &amp; efficient Electrical EPC works</b>."',
    person: 'Ms. Nilambari Bhandare',
    role: 'PMO',
    company: 'Nxtra by Airtel',
    initials: 'NB',
    initialsGradient: 'from-[var(--orange)] to-[var(--orange-soft)]',
    logo: '/clients/logo-6.webp',
  },

  // 3) CtrlS Datacenters
  {
    id: 'ctrls',
    badge: 'Hyperscale · Data Centre',
    quoteHtml:
      '"Tricolite Energy Solutions has <b>successfully commissioned the electrical EPC works</b> including <em>16 MW power distribution</em> and internal data centre electrification at CtrlS Datacenters, MIDC Navi Mumbai. Scope covered <b>Outdoor MV Panels, LV BLOKSET Panels, 2 × 3750 kVA transformers, 4 × 2000 kVA DGs, 32,000 m of HT &amp; LT cabling</b>, earthing &amp; safety systems and internal datacenter POD works — PAHU, PDU &amp; server cabling."',
    person: 'Mr. Brahma Reddy',
    role: 'Sr. Vice President — Projects',
    company: 'CtrlS Datacenters',
    initials: 'BR',
    initialsGradient: 'from-[#1aa64f] to-[#0e7a37]',
    logo: '/clients/logo-23.webp',
  },

  // 4) DaeMyoung Engineering
  {
    id: 'daemyoung',
    badge: 'Industrial EPC · Quality',
    quoteHtml:
      '"It is exemplary that complete works including SITC of Electrical EPC met <b>first-time right and total-quality</b> standard in accordance to all contract specifications. The quality of work is of <em>very good standard</em>. A total of <b>6,31,248 accident-free safe manhours</b> were recorded at site between mobilization to handing over. M/s DaeMyoung Engineering India is pleased to endorse Tricolite Energy Solutions for all such Industrial Electrical EPC Works in the future."',
    person: 'Mr. JS Kim',
    role: 'Director',
    company: 'DaeMyoung Engineering',
    initials: 'JK',
    initialsGradient: 'from-[#0b3d91] to-[#06296b]',
    logo: '/clients/daemyoung.png',
  },

  // 5) Bikanervala (Bikano YEW)
  {
    id: 'bikanervala',
    badge: '33 kV Substation · EPC',
    quoteHtml:
      '"Tricolite Energy Solutions possesses <b>engineering skills and know-how</b> which they demonstrated throughout the execution of this project. The quality of work carried out is of <em>very good standard</em>. A total of <b>2,01,600 accident-free safe manhours</b> were recorded at site. They have <em>completed their scope of work before time</em> — <b>33 kV substation including underground cabling and associated low-side works</b> at our Yamuna Expressway plant."',
    person: 'Mr. Sanjay Verma',
    role: 'General Manager — Project',
    company: 'Bikanervala Foods',
    initials: 'SV',
    initialsGradient: 'from-[#c2261b] to-[#7d1611]',
    logo: '/clients/logo-22.webp',
  },

  // 6) Mother Dairy
  {
    id: 'mother-dairy',
    badge: 'Food Processing · EPC',
    quoteHtml:
      '"M/s Tricolite Energy Solutions has <b>successfully commissioned the electrical EPC works</b> at our Fruit &amp; Vegetable Processing Plant, Ranchi and Milk Process Plant, Nagpur. Scope included <em>Medium Voltage Panels, Transformers, Diesel Generators, LV &amp; MCC Panels, HT/LT Cables, Earthing System</em> and electrical liaisoning. The entire project has been <b>completed satisfactorily and handed over for operation</b>."',
    person: 'Mr. Shriyans Kumar',
    role: 'Dy. Manager — Project & Engineering',
    company: 'Mother Dairy',
    initials: 'SK',
    initialsGradient: 'from-[#1c4fa8] to-[#0c3b8a]',
    logo: '/clients/logo-3.webp',
  },

  // 7) DS Group
  {
    id: 'ds-group',
    badge: 'Quality · ISO 9001',
    quoteHtml:
      '"We at <b>DS Group</b> are pleased to acknowledge the <em>excellent work</em> carried out by Tricolite Energy at our site B-02, Ecotech Extension One, Greater Noida. They successfully executed the <b>electrical high-side and low-side works</b>, including the installation of a <em>3 MVA transformer</em>. Their team demonstrated <b>professionalism, technical expertise, and commitment</b> to timely project completion. We highly recommend TRICOLITE ENERGY for any complex electrical installations."',
    person: 'Mr. Ashok Kumar',
    role: 'AGM — Estate Management',
    company: 'DS Group',
    initials: 'AK',
    initialsGradient: 'from-[var(--orange)] to-[var(--orange-soft)]',
    logo: '/clients/logo-26.webp',
  },

  // 8) MASU Brakes
  {
    id: 'masu',
    badge: 'Safety · ISO 45001',
    quoteHtml:
      '"The entire electrical works executed in <em>stipulated time</em> with <b>excellent quality and workmanship</b>. The firm consists of highly professional and experienced management together with a dedicated and skilled site team. They are capable of undertaking <b>larger EPC electrical works</b>. Entire works was executed in <em>65,000 safe man-hours with zero quality defects</em>. It was a pleasure working with them. We wish M/s TRICOLITE ENERGY Solutions all the very best."',
    person: 'Mr. R Selva',
    role: 'GM Operations',
    company: 'MASU Brakes',
    initials: 'RS',
    initialsGradient: 'from-[var(--blue)] to-[var(--blue-deep)]',
    logo: '/clients/logo-2.webp',
  },
];
